import React from 'react';
import { Card, CardContent } from '../ui/card';
import { MapPin } from 'lucide-react';

const CommuneCareTab = ({ careCentersFull }) => {
    const totalCap = careCentersFull.reduce((a, c) => a + (c.capacity || 0), 0);
    const totalCur = careCentersFull.reduce((a, c) => a + (c.current_count || 0), 0);
    const totalPct = totalCap > 0 ? Math.round((totalCur / totalCap) * 100) : 0;
    const open = careCentersFull.filter(c => c.status === 'open').length;

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                <Card className="stat-card border-l-blue-500"><CardContent className="p-0"><p className="stat-value">{careCentersFull.length}</p><p className="stat-label">Centres</p></CardContent></Card>
                <Card className="stat-card border-l-emerald-500"><CardContent className="p-0"><p className="stat-value">{open}</p><p className="stat-label">Ouverts</p></CardContent></Card>
                <Card className="stat-card border-l-cyan-500"><CardContent className="p-0"><p className="stat-value">{totalCur}<span className="text-sm font-normal text-zinc-500">/{totalCap}</span></p><p className="stat-label">Occupation totale</p></CardContent></Card>
                <Card className="stat-card border-l-amber-500"><CardContent className="p-0"><p className="stat-value">{totalPct}%</p><p className="stat-label">Taux global</p></CardContent></Card>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                {careCentersFull.map(c => {
                    const pct = c.capacity > 0 ? Math.round(((c.current_count || 0) / c.capacity) * 100) : 0;
                    const barColor = pct > 80 ? 'bg-red-500' : pct > 50 ? 'bg-amber-500' : 'bg-emerald-500';
                    const isOpen = c.status === 'open';
                    return (
                        <Card key={c.id} className="content-card" data-testid={`care-card-${c.id}`}>
                            <CardContent className="p-4 space-y-3">
                                <div className="flex items-start justify-between gap-2">
                                    <div className="min-w-0">
                                        <h3 className="text-white font-semibold text-sm truncate">{c.name}</h3>
                                        <p className="text-xs text-zinc-400 flex items-center gap-1 mt-0.5"><MapPin className="w-3 h-3 flex-shrink-0" /><span className="truncate">{c.address}</span></p>
                                    </div>
                                    <span className={`px-2 py-0.5 rounded text-[10px] flex-shrink-0 ${isOpen ? 'bg-emerald-500/15 text-emerald-400' : 'bg-red-500/15 text-red-400'}`}>{isOpen ? 'Ouvert' : 'Ferme'}</span>
                                </div>
                                <div>
                                    <div className="flex justify-between text-xs mb-1">
                                        <span className="text-zinc-400">Occupation</span>
                                        <span className="font-mono text-white">{c.current_count || 0}/{c.capacity} ({pct}%)</span>
                                    </div>
                                    <div className="w-full h-2 bg-zinc-700 rounded-full overflow-hidden">
                                        <div className={`h-full transition-all ${barColor}`} style={{ width: `${Math.min(100, pct)}%` }}></div>
                                    </div>
                                </div>
                                {c.phone && <p className="text-xs text-zinc-400 flex items-center gap-1"><span className="opacity-50">Tel:</span> <span className="font-mono">{c.phone}</span></p>}
                                {c.notes && <p className="text-xs text-zinc-500 line-clamp-2 italic">{c.notes}</p>}
                            </CardContent>
                        </Card>
                    );
                })}
                {careCentersFull.length === 0 && <Card className="content-card md:col-span-2 xl:col-span-3"><CardContent className="p-8 text-center text-zinc-500">Aucun centre CARE</CardContent></Card>}
            </div>
        </div>
    );
};

export default CommuneCareTab;
